import { render, staticRenderFns } from "./PushComponent.vue?vue&type=template&id=625c4bda&scoped=true"
import script from "./PushComponent.vue?vue&type=script&lang=js"
export * from "./PushComponent.vue?vue&type=script&lang=js"
import style0 from "./PushComponent.vue?vue&type=style&index=0&id=625c4bda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c4bda",
  null
  
)

export default component.exports